import Instance from "./instance";

export const GetRetentionState = async (campaignId) => {
  try {
    return await Instance.instanceToken.get(`/dev/retention-state`, { params: { campaignId } });
  } catch (error) {
    return error;
  }
};

export const SimulateRetention = async (campaignId, action, daysAgo) => {
  try {
    return await Instance.instanceToken.post(`/dev/simulate-retention`, { campaignId, action, daysAgo });
  } catch (error) {
    return error;
  }
};
